/**
 * TTS 资源库的数据请求（TanStack Query），接口与参数与旧版页面一致
 */
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ttsApi, type TTSListParams, type TTSListResponse } from '@/api/services/tts'

const TTS_KEY = ['admin', 'tts'] as const

export function useTTSList(params: TTSListParams) {
  return useQuery({
    queryKey: [...TTS_KEY, 'list', params],
    queryFn: async () => {
      const response = await ttsApi.getList(params)
      // 该接口直接返回分页对象，不包 ApiResponse 外壳
      return response.data as unknown as TTSListResponse
    },
    placeholderData: keepPreviousData
  })
}

export function useDeleteTTS() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => ttsApi.delete(id),
    // 删除会连同音频文件一起删掉，不自动重试
    retry: false,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TTS_KEY })
  })
}

export function useBatchDeleteTTS() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (ids: number[]) => ttsApi.batchDelete(ids),
    retry: false,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TTS_KEY })
  })
}
